interface PageData {
    [pathname: string]: {
        title: string;
        metaDescription: string;
    };
  }

const baseMetaDescription = "Katon Virtual School";
export const pageData:  PageData = {
    "/": {
        title: "Landing Page",
        metaDescription: `${baseMetaDescription} landing page`
    },
    "/teacher-login": {
        title: "Teacher Login",
        metaDescription: `${baseMetaDescription} teacher login page`
    },
    "/teacher-select-class": {
        title: "Teacher Select Class",
        metaDescription: `${baseMetaDescription} teacher select class page`
    },
    "/teacher-settings/profile": {
        title: "Teacher Profile",
        metaDescription: `${baseMetaDescription} teacher profile page`
    },
    "/student-signup": {
        title: "Student Signup",
        metaDescription: `${baseMetaDescription} student signup page`
    },
    "/student-login": {
        title: "Student Login",
        metaDescription: `${baseMetaDescription} student login page`
    },
    "/faq": {
        title: "Faq",
        metaDescription: `${baseMetaDescription} faq page`
    },
    "/legal": {
        title: "legal",
        metaDescription: `${baseMetaDescription} legal page`
    },
    "/support": {
        title: "support",
        metaDescription: `${baseMetaDescription} support page`
    },
    "/teacher-classroom": {
        title: "Teacher Classroom",
        metaDescription: `${baseMetaDescription} teacher classroom page`
    },
    "/teacher-classroom/ebooks": {
        title: "Teacher Classroom Ebooks",
        metaDescription: `${baseMetaDescription} teacher classroom ebooks`
    },
    "/teacher-classroom/images": {
        title: "Teacher Classroom Images",
        metaDescription: `${baseMetaDescription} teacher classroom images`
    },
    "/teacher-classroom/podcast": {
        title: "Teacher Classroom Podcast",
        metaDescription: `${baseMetaDescription} teacher classroom podcast page`
    },
    "/teacher-classroom/podcast/materials": {
        title: "Teacher Classroom Podcast Materials",
        metaDescription: `${baseMetaDescription} teacher classroom podcast materials page`
    },
    "/teacher-classroom/videos": {
        title: "Teacher Classroom Videos",
        metaDescription: `${baseMetaDescription} teacher classroom videos page`
    },
    "/teacher-classroom/ebooks/materials": {
        title: "Teacher Classroom Ebooks Materials",
        metaDescription: `${baseMetaDescription} teacher classroom ebooks page`
    },
    "/teacher-classroom/images/materials": {
        title: "Teacher Classroom Images Materials",
        metaDescription: `${baseMetaDescription} teacher classroom images materials page`
    },
    "/teacher-classroom/videos/materials": {
        title: "Teacher Classroom Videos Materials",
        metaDescription: `${baseMetaDescription} teacher classroom videos materials page`
    },
    "/teacher-announcement": {
        title: "Teacher Announcement",
        metaDescription: `${baseMetaDescription} teacher announcement page`
    },
    "/teacher-classroom/ebooks/materials/teaching-materials": {
        title: "Teacher Classroom Ebooks Teaching Materials",
        metaDescription: `${baseMetaDescription} teacher classroom ebooks materials page`
    },
    "/teacher-classroom/ebooks/materials/examination-guide": {
        title: "Teacher Classroom Ebooks Examination Guideline",
        metaDescription: `${baseMetaDescription} teacher classroom ebooks materials examination guideline page`
    },
    "/teacher-classroom/ebooks/materials/question-bank": {
        title: "Teacher Classroom Ebooks Question Bank",
        metaDescription: `${baseMetaDescription} teacher classroom ebooks question bank`
    },
    "/teacher-classroom/liveclass": {
        title: "Teacher Classroom Liveclass",
        metaDescription: `${baseMetaDescription} teacher classroom liveclass page`
    },
    "/teacher-settings'": {
        title: "Teacher Settings",
        metaDescription: `${baseMetaDescription} teacher settings page`
    },
    "/student-classroom": {
        title: "Student Classroom",
        metaDescription: `${baseMetaDescription} student classroom page`
    },
    "/student-classroom/ebooks": {
        title: "Student Classroom Ebooks",
        metaDescription: `${baseMetaDescription} student classroom ebooks page`
    },
    "/student-classroom/images": {
        title: "Student Classroom Images",
        metaDescription: `${baseMetaDescription} student classroom images page`
    },
    "/student-classroom/videos": {
        title: "Student Classroom Videos",
        metaDescription: `${baseMetaDescription} student classroom videos page`
    },
    "/student-classroom/ebooks/materials": {
        title: "Student Classroom Ebooks Materials",
        metaDescription: `${baseMetaDescription} student classroom ebooks materials page`
    },
    "/student-classroom/images/materials": {
        title: "Student Classroom Images Materials",
        metaDescription: `${baseMetaDescription} student classroom images materials page`
    },

    "/student-classroom/videos/materials": {
        title: "Student Classroom Videos Materials",
        metaDescription: `${baseMetaDescription} student classroom videos materialspage`
    },
    "/student-classroom/ebooks/materials/learning-materials": {
        title: "Student Classroom Ebooks Learning Materials",
        metaDescription: `${baseMetaDescription} student classroom ebooks learning materials page`
    },

    "/student-classroom/ebooks/materials/examination-guide": {
        title: "Student Classroom Ebooks Examination Guideline",
        metaDescription: `${baseMetaDescription} student classroom ebooks examination guideline page`
    },
    "/student-classroom/ebooks/materials/question-bank": {
        title: "Student Classroom Ebooks Question Bank",
        metaDescription: `${baseMetaDescription} school admin system message page`
    },
    "/student-classroom/liveclass": {
        title: "Student Classroom Liveclass",
        metaDescription: `${baseMetaDescription} student classroom liveclass page`
    },
    "/student-classroom/assignments": {
        title: "Student Classroom Assignments",
        metaDescription: `${baseMetaDescription} student classroom assignments page`
    },
    "/student-classroom/podcast": {
        title: "Student Classroom Podcast",
        metaDescription: `${baseMetaDescription} student classroom podcast page`
    },
    "/student-classroom/podcast/materials": {
        title: "student classroom podcast materials",
        metaDescription: `${baseMetaDescription} student classroom podcast materials page`
    },
    "/student-announcement": {
        title: "Student Announcement",
        metaDescription: `${baseMetaDescription} student announcement page`
    },
    "/teacher-classroom/liveclass/meeting": {
        title: "Teacher Classroom Liveclass Meeting",
        metaDescription: `${baseMetaDescription} teacher classroom liveclass meeting page`
    },
    "/student-classroom/liveclass/meeting": {
        title: "Student Classroom Liveclass Meeting",
        metaDescription: `${baseMetaDescription} student classroom liveclass meeting page`
    },
    "/student-settings": {
        title: "Student Settings",
        metaDescription: `${baseMetaDescription} student settings page`
    },
    "/student-settings/profile": {
        title: "Student Profile",
        metaDescription: `${baseMetaDescription} student profile page`
    },
    "/virtual-school/virtual-student-forgot-password": {
        title: "Virtual Student Forgot Password",
        metaDescription: `${baseMetaDescription} virtual student forgot password page`
    },
    "/virtual-school/virtual-teacher-login": {
        title: "Virtual Teacher Login",
        metaDescription: `${baseMetaDescription} virtual teacher login page`
    },
    "/virtual-school/virtual-student-signup": {
        title: "Virtual Student Signup",
        metaDescription: `${baseMetaDescription} virtual student signup page`
    },
    "/virtual-school/virtual-student-login": {
        title: "Virtual Student Login",
        metaDescription: `${baseMetaDescription} virtual student login page`
    },
    "/virtual-school/student-classroom": {
        title: "Virtual Student Classroom",
        metaDescription: `${baseMetaDescription} virtual student classroom page`
    },
    "/virtual-school/teacher-classroom": {
        title: "Virtual Teacher Classroom",
        metaDescription: `${baseMetaDescription} virtual teacher classroom page`
    },
}